// Customizable Area Start
import React, { useState } from "react";
import { Box, Button, TextField, Typography } from "@material-ui/core";
import { StepNameProps } from "./types";

const NAME_REGEX = /^[a-zA-ZÀ-ÿ\s'-]*$/;

const StepName: React.FC<StepNameProps> = ({
  firstName,
  lastName,
  onFirstNameChange,
  onLastNameChange,
  onContinue,
}) => {
  const [firstNameError, setFirstNameError] = useState("");
  const [lastNameError, setLastNameError] = useState("");

  const handleFirstName = (v: string) => {
    if (v && !NAME_REGEX.test(v)) return;
    setFirstNameError("");
    onFirstNameChange(v);
  };

  const handleLastName = (v: string) => {
    if (v && !NAME_REGEX.test(v)) return;
    setLastNameError("");
    onLastNameChange(v);
  };

  const handleContinue = () => {
    let valid = true;
    if (!firstName.trim()) {
      setFirstNameError("First name is required.");
      valid = false;
    }
    if (!lastName.trim()) {
      setLastNameError("Last name is required.");
      valid = false;
    }
    if (valid) onContinue();
  };

  return (
    <Box>
      <Typography
        style={{
          fontSize: 20,
          fontWeight: 700,
          fontFamily: "Inter",
          marginBottom: 8,
          textAlign: "center",
          color: "#0F172A",
        }}
      >
        Great start!
      </Typography>
      <Typography
        variant="body2"
        style={{
          textAlign: "center",
          marginBottom: 28,
          fontFamily: "Inter",
          color: "#64748B",
          lineHeight: 1.6,
        }}
      >
        {`Let's add a personal touch to your comment. What's your first and last name?`}
      </Typography>

      <TextField
        variant="outlined"
        fullWidth
        label="First Name"
        value={firstName}
        onChange={(e) => handleFirstName(e.target.value)}
        error={!!firstNameError}
        helperText={firstNameError}
        style={{ marginBottom: 16 }}
        inputProps={{ autoFocus: true, autoComplete: "given-name" }}
      />
      <TextField
        variant="outlined"
        fullWidth
        label="Last Name"
        value={lastName}
        onChange={(e) => handleLastName(e.target.value)}
        error={!!lastNameError}
        helperText={lastNameError}
        style={{ marginBottom: 28 }}
        inputProps={{ autoComplete: "family-name" }}
      />

      <Button
        variant="contained"
        fullWidth
        onClick={handleContinue}
        style={{
          backgroundColor: "#000",
          color: "#fff",
          borderRadius: 24,
          textTransform: "none",
          padding: "13px 0",
          fontSize: 16,
          fontFamily: "Inter",
          fontWeight: 600,
        }}
      >
        Continue
      </Button>
    </Box>
  );
};

export default StepName;
// Customizable Area End
